import { PostStatus } from '../constants';
import { Type } from './action-types';
import { TwitterAction, TwitterState, twitterStateFactory } from './types';

const defaultState = twitterStateFactory();

export default function(
  state: TwitterState = defaultState,
  action: TwitterAction,
) {
  switch (action.type) {
    case Type.TWITTER_USER_DATA_GET_SUCCESS: {
      const { profileImageUrl, username } = action.payload;

      return state
        .set('username', username)
        .set('profileImageUrl', profileImageUrl);
    }

    case Type.TWITTER_USER_DATA_CLEAR:
      return twitterStateFactory();

    case Type.TWITTER_VIDEO_POST_REQUEST:
      return state.set('postStatus', PostStatus.IN_PROGRESS);

    case Type.TWITTER_VIDEO_POST_SUCCESS: {
      const { socialShareId } = action.payload;
      return state.set('socialShareId', socialShareId);
    }

    case Type.TWITTER_VIDEO_POST_FAILURE:
    case Type.TWITTER_VIDEO_POST_AWAIT_FAILURE:
      return state.set('postStatus', PostStatus.FAILURE);

    case Type.TWITTER_VIDEO_POST_AWAIT_SUCCESS:
      return state.set('postStatus', PostStatus.SUCCESS);

    case Type.TWITTER_AUTHORIZE_SUCCESS: {
      return state.merge(action.payload);
    }

    default:
      return state;
  }
}
